export const thumbsUpEmojiId = '1f44d';
